/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text-blue[_ngcontent-%COMP%]{color:#1e34ff}.text-light-blue[_ngcontent-%COMP%]{color:#0064c5}.text-black[_ngcontent-%COMP%]{color:#000}.page-wrapper[_ngcontent-%COMP%]{min-height:100vh;display:flex;flex-direction:column}.page-content[_ngcontent-%COMP%]{flex:1;background-color:#fbfbfb;background-attachment:fixed;background-position:center bottom;background-repeat:no-repeat;background-size:cover;padding-bottom:30px}"];
export { styles as styles };
